<template>
  <a-spin :spinning="spinning">
    <a-form :form="form">

      <a-form-item label="标题" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input
          name="name"
          v-decorator="['name', { rules: [{ required: true, message: '请输入友链名称' }] }]"
        />
      </a-form-item>
      <a-form-item label="合作类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-select
          placeholder="请选择合作类型"
          name="type"
          @change="handleSelectMode"
          v-decorator="['type', { rules: [{ required: true, message: '请选择合作类型' }] }]"
        >
          <a-select-option value="1">基金会</a-select-option>
          <a-select-option value="2">合作机构</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="合作伙伴类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-select
          placeholder="请选择合作伙伴类型"
          name="partnerType"
          @change="handleSelectType"
          v-decorator="['partnerType', { rules: [{ required: true, message: '请选择合作伙伴类型' }] }]"
        >
          <a-select-option value="1">合作伙伴</a-select-option>
          <a-select-option value="2">优秀合作伙伴</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item label="上传LOGO" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <img-upload
          name="thum"
          v-decorator="['logo', { rules: [{ required: true, message: '请上传LOGO' }] }]"
        />
      </a-form-item>
      <a-form-item label="链接" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input
          name="href"
          v-decorator="['href', { rules: [{ type: 'url', required: true, message: '请输入正确的链接' }] }]"
        />
      </a-form-item>
      <a-form-item label="排序" :labelCol="labelCol" :wrapperCol="wrapperCol" help="默认0，值越大越靠前">
        <a-input
          name="order"
          v-decorator="[
            'order',
            {
              initialValue: 0
            }
          ]"
        />
      </a-form-item>
      <a-form-item label="状态" :labelCol="labelCol" :wrapperCol="wrapperCol" help="默认展示">
        <a-switch
          checked-children="展示"
          un-checked-children="隐藏"
          name="state"
          v-decorator="[
            'state',
            {
              valuePropName: 'checked',
              initialValue: true
            }
          ]"
        />
      </a-form-item>
      <a-form-item label="简介" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-textarea
          rows="4"
          name="brief"
          placeholder="请输入简介"
          v-decorator="['brief', { rules: [{ required: false, message: '请输入简介' }] }]"
        />
      </a-form-item>
    </a-form>
  </a-spin>
</template>

<script>
import pick from 'lodash.pick'
import { ImgUpload } from '@/components'
import { requestGet, requestPost, requestPut } from '@/api/api'
const fields = ['name', 'href', 'logo', 'order', 'state', 'type', 'partnerType', 'brief']

export default {
    name: 'ModelForm',
    props: {
        aid: {
            type: Number,
            default: null
        }
    },
    components: {
        ImgUpload
    },
    data () {
        return {
            selectMode: 1, // 模式 1基金会 2合作机构
            selectType: 1, // 类型 1合作伙伴 2优秀合作伙伴
            spinning: false, // 页面加载
            labelCol: {
                xs: { span: 24 },
                sm: { span: 7 }
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 13 }
            },
            form: this.$form.createForm(this)
        }
    },
    mounted () {
        if (this.aid) {
            this.getLink(this.aid) // 获取编辑友链信息
        }
    },
    methods: {
        /**
         * 获取编辑友链信息
         * @id
         */
        getLink (id) {
            this.spinning = true
            requestGet('/partners/links/' + id)
                .then(res => {
                    res.result.state = res.result.state === 1
                    res.result.type = res.result.type.toString()
                    res.result.partnerType = res.result.partnerType.toString()
                    setTimeout(() => {
                        this.form.setFieldsValue(pick(res.result, fields))
                    }, 1000)
                })
                .finally(() => {
                    this.spinning = false
                })
        },

        handleSelectMode (key) {
            this.selectMode = key
        },

        handleSelectType (key) {
            this.selectType = key
        },
        /**
         * 提交按钮
         * form表单提交
         * @form
         */
        onOk () {
            const {
                form: { validateFields }
            } = this
            return new Promise(resolve => {
                validateFields((errors, values) => {
                    if (!errors) {
                        values.state = values.state ? 1 : 2 // 状态 1正常 2隐藏
                        if (this.aid) {
                            const url = '/partners/links/' + this.aid
                            requestPut(url, values)
                                .then(res => {
                                    this.$notification.success({
                                        message: '提示',
                                        description: res.msg,
                                        duration: 2
                                    })
                                    resolve(true)
                                })
                        } else {
                            const url = '/partners/links/create'
                            requestPost(url, values)
                                .then(res => {
                                    this.$notification.success({
                                        message: '提示',
                                        description: res.msg,
                                        duration: 2
                                    })
                                    resolve(true)
                                })
                        }
                    }
                })
            })
        },
        onCancel () {
            return new Promise(resolve => {
                resolve(true)
            })
        }
    }
}
</script>

<style>
.avatar-uploader > .ant-upload {
    width: 128px;
    height: 128px;
}
.ant-upload-select-picture-card i {
    font-size: 32px;
    color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
    margin-top: 8px;
    color: #666;
}
</style>
